import { Stand, config } from 'src/config'

export interface StandMeta {
  name: string
  titleColor: string
  sidebarColor: string
}

const standMetaMap: Record<Stand, StandMeta> = {
  dev: {
    name: 'Develop',
    titleColor: 'rgba(0, 0, 0, 0.12)',
    sidebarColor: '#4D5F7A'
  },
  dev2: {
    name: 'Develop 2',
    titleColor: 'rgba(0, 0, 0, 0.12)',
    sidebarColor: '#4D5F7A'
  },
  staging: {
    name: 'Staging',
    titleColor: 'rgba(0, 0, 0, 0.12)',
    sidebarColor: '#4D5F7A'
  },
  production: {
    name: 'Production',
    titleColor: '#F04848',
    sidebarColor: 'primary.main'
  }
}

export const getStandMeta = (): StandMeta =>
  standMetaMap[config.stand] || {
    ...standMetaMap.production,
    name: 'Stand is not defined'
  }
